import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext.tsx';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return <Navigate to="/" replace />;
  return <>{children}</>;
}
